import { render, staticRenderFns } from "./RelatorioParecerDescritivo.vue?vue&type=template&id=51b53447&"
import script from "./RelatorioParecerDescritivo.vue?vue&type=script&lang=js&"
export * from "./RelatorioParecerDescritivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports